RCDPW.module('RCDPW.validator', {
    setup: function () {
        if (!$.validator) {
            return;
        }

        // Pattern from SW
        var validEmailPattern = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

        $.validator.addMethod('phoneNumber', function (value, element) {
            return /[-\d\(\)\t ]+/.test(value);
        });

        $.validator.addMethod('freeSignUpPhoneNumber', function (value) {
            return /^[-\d()\t +]+$/.test(value);
        });

        $.validator.addMethod('freeSignUpStaticText', function (value) {
            return /^((?!(<|>|\/|")).)*$/.test(value);
        });

        $.validator.addMethod('customEmail', function (value, element) {
            return validEmailPattern.test(value);
        });

        $.validator.addMethod('customEmailWithBackList', function (value, element) {

            return validEmailPattern.test(value) && isDomainValid(value);

            function isDomainValid(value) {
                var invalidDomains = [
                    /^test.com$/i,
                    /^example.com$/i,
                    /^1.com$/i,
                    /^2.com$/i
                ];
                var domain = value.split('@')[1];
                return _.every(invalidDomains, function (invalidDomain) {
                    return !invalidDomain.test(domain);
                });
            }
        });

        $.validator.addMethod('ext', function (value, element) {
            return this.optional(element) || /\d+/.test(value);
        });

        $.validator.addMethod('optionalComment', function (value, element) {
            return this.optional(element) || value.length <= 500;
        });
        //deprecated
        $.validator.addMethod('positiveInt', function (value, element) {
            return /\d+/.test(value) && value >= 0;
        });
        $.validator.addMethod('positiveInteger', function (value, element) {
            if (value && value.trim()) {
                return /^\d+$/.test(value);
            }
            return true;
        });

        $.validator.addMethod('dateFromNow', function (value, element) {
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var selectedTime = (new Date(value)).getTime();
            return selectedTime >= today.getTime();
        });

        $.validator.addMethod('noWhiteSpace', function (value) {
            return value.trim().length !== 0;
        });

        $.validator.setDefaults({
            errorPlacement: function () {

            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids()) {
                    return;
                }
                var $firstInvalidElement = $(validator.errorList[0].element);

                // Find closest parent if $firstInvalidElement is not visible.
                if (!$firstInvalidElement.is(':visible')) {
                    $firstInvalidElement = $firstInvalidElement.closest(':visible')
                }

                $('html, body').animate({
                    scrollTop: $firstInvalidElement.offset().top
                }, 100);
            }
        });
    }
});
